module.exports = __webpack_public_path__ + "static/media/33-14.d1a5ac59.mp3";